export interface Table {
  id: string;
  number: number;
  name?: string;
  status: 'available' | 'occupied' | 'reserved' | 'cancelled';
  seats: number;
  orders: Order[];
  timeOpened?: Date;
  observations?: string;
  cancelReason?: string;
  cancelDate?: Date;
  createdAt?: Date;
}

export interface Category {
  id: string;
  name: string;
  image?: string;
}

export interface Product {
  id: string;
  name: string;
  description: string;
  price: number;
  categoryId: string;
  image?: string;
  available?: boolean;
  code?: string;
  stock?: number;
  unit?: string;
  brand?: string;
  erpProductId?: number;
}

export interface OrderItem {
  id: string;
  productId: string;
  product: Product;
  quantity: number;
  notes?: string;
  status: 'pending' | 'preparing' | 'ready' | 'delivered' | 'cancelled';
  cancelReason?: string;
}

// Define the VendaFormaPagamento interface
export interface VendaFormaPagamento {
  FormaPagamentoID: number;
  FormaPagamentoNome: string;
  Valor: number;
  DataVencimento: string;
}

export interface Order {
  id: string;
  tableId: string;
  tableNumber?: number;
  name?: string;
  items: OrderItem[];
  status: 'open' | 'paid' | 'cancelled';
  type: 'dine-in' | 'delivery' | 'pickup' | 'takeout';
  createdAt: Date;
  updatedAt: Date;
  totalAmount: number;
  discount?: number;
  discountType?: 'percentage' | 'fixed';
  paymentMethodId?: string;
  receivedAmount?: number;
  changeAmount?: number;
  paymentDate?: Date;
  cancelReason?: string;
  customerId?: string;
  customerName?: string;
  syncStatus?: 'pending' | 'synced' | 'failed';
  lastSyncDate?: Date;
  syncError?: string;
  erpId?: number;
  externalId?: string;
  document?: string;
  observations?: string;
  VendaFormaPagamento?: VendaFormaPagamento[];
}

export interface Customer {
  id: string;
  name: string;
  document?: string;
  phone?: string;
  email?: string;
  address?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  observations?: string;
  clienteID?: number;
  vendedorID?: number;
  limite?: number;
  isNew?: boolean;
  exported?: boolean;
  businessID?: number;
  personID?: number;
  im?: string;
  ie?: string;
  taxpayerType?: number;
  isFinalConsumer?: boolean;
  status?: number;
}

export enum IndicadorPagamento {
  AVista = 1,
  APrazo = 2
}

export enum PeriodicidadePagamento {
  Diario = 1,
  Semanal = 2,
  Quinzenal = 3,
  Mensal = 4,
  Bimestral = 5,
  Trimestral = 6,
  TrintaECincoDias = 7,
  QuarentaDias = 8,
  QuarentaECindoDiasDias = 9,
  Semestral = 10,
  Anual = 11,
  Bienal = 12,
  Outro = 99
}

export enum MeioPagamento {
  Dinheiro = 1,
  Cheque = 2,
  CartaoCredito = 3,
  CartaoDebito = 4,
  CreditoLoja = 5,
  ValeAlimentacao = 10,
  ValeRefeicao = 11,
  ValePresente = 12,
  ValeCombustivel = 13,
  Boleto = 15,
  SemPagamento = 90,
  Pix = 17,
  Outros = 99
}

export interface PaymentMethod {
  id: string;
  name: string;
  description?: string;
  enabled: boolean;
  icon?: string;
  type?: 'cash' | 'credit' | 'debit' | 'pix' | 'other';
  ID?: number;
  Descricao?: string;
  FormaPagamentoID?: number;
  IndicadoPagamento?: IndicadorPagamento;
  QuantidadeParcelas?: number;
  DiasIntervalo?: number;
  PeridiocidadePagamento?: PeriodicidadePagamento;
  MeioPagamento?: MeioPagamento;
}

export interface VendaFormaPagto {
  formaPagtoId: number;
  descricao: string;
  valor: number;
}

export interface ErpVendaRequest {
  ID: number;
  Data: string;
  FormaPagamentoID: number;
  VendaID: number;
  IdentificadorVendaPDV: string;
  EmpresaID: number;
  ClienteID: number;
  VendedorID: number;
  TipoOperacaoID: number;
  ValorDesconto: number;
  TotalPedido: number;
  Observacao?: string;
  CpfCnpjCliente?: string;
  Troco: number;
  NumeroComanda?: string;
  VendaItem: ErpVendaItem[];
  VendaFormaPagamento: ErpVendaFormaPagamento[];
}

export interface ErpVendaItem {
  ProdutoID: number;
  ProdutoNome: string;
  Quantidade: number;
  Valor: number;
  SubTotal: number;
  ValorDesconto: number;
  Total: number;
  UnidadeMedidaID: number;
}

export interface ErpVendaFormaPagamento {
  FormaPagamentoID: number;
  FormaPagamentoNome: string;
  Valor: number;
  DataVencimento: string;
}
